import React from 'react';
import styled from 'styled-components';
import TitleLayout from '../../kosherTeudot/generic/TitleLayout';
import TitleRow from '../../kosherTeudot/generic/TitleRow';
import TitleRowItem from '../../kosherTeudot/generic/TitleRowItem';
import EditIcon from '../../../../../generic/icons/IconLib/PencilIcon';
import PackageIcon from '../../../../../generic/icons/IconLib/PackageBoxIcon';
import ScalesIcon from '../../../../../generic/icons/IconLib/ScaleIcon';
import UserIcon from '../../../../../generic/icons/IconLib/UserIcon';
import WarehouseIcon from '../../../../../generic/icons/IconLib/WarehouseIcon';

const TitleContainer = styled.div`
    position: relative;
    width: 100%;
`;

const EditIconWrapper = styled.div`
    position: absolute;
    top: 50%;
    left: 0.5em;
    transform: translateY(-50%);
    cursor: pointer;
    z-index: 2;
    padding: 5px;
    background: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5em;
    &:hover {
        background: #f0f0f0;
    }
    
    svg {
        color: #297F76; /* Match the color of other icons */
    }
`;

interface PalletDetailsTitleProps {
    customerName: string;
    warehouseName: string;
    totalPackages: number;
    totalWeight: number;
    onEditClick: () => void;
}

const PalletDetailsTitle: React.FC<PalletDetailsTitleProps> = ({ 
    customerName, 
    warehouseName, 
    totalPackages, 
    totalWeight,
    onEditClick
}) => {
    return (
        <TitleContainer>
            <TitleLayout>
                <TitleRow>
                    <TitleRowItem 
                        name={customerName || ''}
                        icon={<UserIcon />}
                    />
                </TitleRow>
                <TitleRow>
                    <TitleRowItem 
                        name={warehouseName || ''}
                        icon={<WarehouseIcon />}
                    />
                </TitleRow>
                <TitleRow>
                    <TitleRowItem 
                        name={`${totalPackages || 0}`}
                        icon={<PackageIcon />}
                    />
                    <TitleRowItem 
                        name={`${totalWeight || 0}`}
                        icon={<ScalesIcon />}
                    />
                </TitleRow>
            </TitleLayout>
            <EditIconWrapper onClick={onEditClick}>
                <EditIcon />
            </EditIconWrapper>
        </TitleContainer>
    );
};

export default PalletDetailsTitle; 